/* Waxit product cards (snippets/wx-card.liquid): size chips, variant picker, add to cart.
   Event delegation on document, so cards added later (load more, filter swaps) work without rebinding.
   data-wxc-more / data-wxc-open are also used by the collection pager and Filter button, so card handlers only act inside a card. */
(function () {
  if (window.__wxCard) return; window.__wxCard = 1;
  var STRIP = /\s*\(.*?\)\s*/g;
  var num = function (s) { return parseFloat(String(s || '').replace(/[^\d.]/g, '')) || 0; };
  var cardOf = function (el) { return el && el.closest('[data-wxc-card]'); };

  function remember(c) {
    if (c.dataset.p0 != null) return;
    var p = c.querySelector('[data-wxc-p]'), s = c.querySelector('[data-wxc-c]'), sv = c.querySelector('[data-wxc-save]');
    c.dataset.p0 = p ? p.textContent : ''; c.dataset.c0 = s && !s.hidden ? s.textContent : ''; c.dataset.s0 = sv && !sv.hidden ? sv.textContent : '';
  }
  /* Point the card's Add button at a variant (or clear it) and show that variant's price. */
  function setVariant(c, id, price, compare, label) {
    var f = c.querySelector('[data-wxc-add]'), b = c.querySelector('[data-wxc-btn]');
    if (!f || !b) return;
    remember(c);
    f.dataset.variant = id || '';
    b.disabled = !id;
    var narrow = c.offsetWidth < 250;
    b.textContent = id ? (label && !narrow ? 'Add ' + label + ' to cart' : 'Add to cart') : b.dataset.wait;
    var p = c.querySelector('[data-wxc-p]'), from = c.querySelector('.wxh-card__price small'), s = c.querySelector('[data-wxc-c]'), sv = c.querySelector('[data-wxc-save]');
    if (id) {
      if (p) p.textContent = price;
      if (from) from.hidden = true;
      if (s) { s.textContent = compare || ''; s.hidden = !compare; }
      /* 5 Oct 2026: % off rounds to the nearest half (12.48 -> 12.5, 14.99 -> 15), same as snippets/wx-card.liquid. Was rounded down. */
      if (sv) { var h = compare ? Math.round((1 - num(price) / num(compare)) * 200) : 0; sv.textContent = (h / 2) + '% off'; sv.hidden = !(h > 0); }
    } else {
      if (p) p.textContent = c.dataset.p0;
      if (from) from.hidden = false;
      if (s) { s.textContent = c.dataset.c0; s.hidden = !c.dataset.c0; }
      if (sv) { sv.textContent = c.dataset.s0; sv.hidden = !c.dataset.s0; }
    }
  }

  function add(id, btn, err, done) {
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    if (err) err.textContent = '';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) })
      .then(function (r) { return r.ok ? r.json() : r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); }); })
      .then(function (state) {
        if (done) done();
        var cd = document.querySelector('cart-drawer');
        if (cd && cd.renderContents && state.sections) cd.renderContents(state); else window.location.href = '/cart';
      })
      .catch(function (x) { if (err) err.textContent = x.message; })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-wxc-add]'); if (!f) return;
    e.preventDefault();
    var id = parseInt(f.dataset.variant, 10); if (!id) return;
    var c = cardOf(f);
    add(id, f.querySelector('button'), c && c.querySelector('[data-wx-err]'));
  });

  document.addEventListener('click', function (e) {
    var ch = e.target.closest('[data-wxc-chip]');
    if (ch && cardOf(ch)) {
      var c = cardOf(ch), on = ch.getAttribute('aria-checked') === 'true';
      c.querySelectorAll('[data-wxc-chip]').forEach(function (x) { x.setAttribute('aria-checked', 'false'); x.classList.remove('is-on'); });
      if (on) { setVariant(c, '', '', '', ''); return; }
      ch.setAttribute('aria-checked', 'true'); ch.classList.add('is-on');
      setVariant(c, ch.dataset.id, ch.dataset.p, ch.dataset.c, ch.dataset.label);
      return;
    }
    var more = e.target.closest('[data-wxc-more]');
    if (more && cardOf(more)) { cardOf(more).querySelectorAll('.wxh-card__chip.is-extra').forEach(function (x) { x.classList.remove('is-extra'); }); more.remove(); return; }
    var op = e.target.closest('[data-wxc-open]');
    if (op && cardOf(op)) { e.preventDefault(); openPicker(cardOf(op), op); }
  });

  /* Picker: one dialog for the page, filled from the card's JSON. Back keeps the choice on the card; Add to cart adds and closes. */
  var dlg, cur;
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function build() {
    if (dlg) return dlg;
    dlg = el('div', 'wxc-pick'); dlg.hidden = true;
    dlg.innerHTML = '<div class="wxc-pick__scrim" data-x></div><div class="wxc-pick__box" role="dialog" aria-modal="true" aria-labelledby="WxcPickTitle" tabindex="-1"><div class="wxc-pick__img"><img alt=""></div><div class="wxc-pick__body"><button type="button" class="wxc-pick__x" data-x aria-label="Close">×</button><div class="wxc-pick__brand"></div><div class="wxc-pick__title" id="WxcPickTitle"></div><div class="wxc-pick__price"></div><div class="wxc-pick__groups"></div><div class="wxc-pick__foot"><button type="button" class="wxc-pick__back" data-x>‹ Back</button><button type="button" class="wxc-pick__add" data-add disabled>Choose an option</button></div><div class="wxc-pick__err" role="alert"></div><a class="wxc-pick__view" href="#">View full product details ›</a></div></div>';
    document.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) {
      if (e.target.closest('[data-x]')) { close(true); return; }
      var o = e.target.closest('[data-opt]');
      if (o && !o.disabled) { var i = +o.dataset.opt, val = o.dataset.val; cur.sel[i] = cur.sel[i] === val ? undefined : val; render(); return; }
      if (e.target.closest('[data-add]')) {
        var m = match(); if (!m || !m.a) return;
        add(m.id, dlg.querySelector('[data-add]'), dlg.querySelector('.wxc-pick__err'), function () { close(true); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dlg && !dlg.hidden) close(true); });
    return dlg;
  }
  function match() {
    var d = cur.data;
    return d.variants.find(function (x) { return d.options.every(function (o, i) { return cur.sel[i] !== undefined && x.o[i] === cur.sel[i]; }); });
  }
  function wordy(values) { return values.some(function (v) { return v.replace(STRIP, '').trim().length > 7; }); }
  function render() {
    var d = cur.data, box = dlg.querySelector('.wxc-pick__groups'), m = match();
    box.innerHTML = '';
    d.options.forEach(function (o, i) {
      if (o.values.length < 2) return;
      var g = el('div', 'wxc-pick__g'), lg = el('div', 'wxc-pick__legend', o.name);
      if (cur.sel[i] !== undefined) { lg.appendChild(document.createTextNode(': ')); lg.appendChild(el('b', '', cur.sel[i])); }
      g.appendChild(lg);
      var rows = wordy(o.values), list = el('div', rows ? 'wxc-pick__rows' : 'wxc-pick__chips');
      o.values.forEach(function (val) {
        var trial = cur.sel.slice(); trial[i] = val;
        var fits = d.variants.filter(function (x) { return d.options.every(function (_, k) { return trial[k] === undefined || x.o[k] === trial[k]; }); });
        var avail = fits.some(function (x) { return x.a; });
        var exact = fits.length === 1 ? fits[0] : null;
        var on = cur.sel[i] === val;
        var b = el('button', (rows ? 'wxc-pick__row' : 'wxc-pick__chip') + (on ? ' is-on' : '') + (avail ? '' : ' is-na'));
        b.type = 'button'; b.dataset.opt = i; b.dataset.val = val; b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (!avail) { b.disabled = true; b.title = 'Sold out'; }
        if (rows) { b.appendChild(el('i')); b.appendChild(el('span', '', val)); b.appendChild(el('b', '', !avail ? 'Sold out' : exact ? exact.p : '')); }
        else b.textContent = val;
        list.appendChild(b);
      });
      g.appendChild(list); box.appendChild(g);
    });
    var pr = dlg.querySelector('.wxc-pick__price'); pr.innerHTML = '';
    if (m) { pr.appendChild(el('strong', '', m.p)); if (m.c) pr.appendChild(el('s', '', m.c)); }
    else { var st = el('strong'); st.appendChild(el('small', '', 'From')); st.appendChild(document.createTextNode(d.from)); pr.appendChild(st); }
    var ab = dlg.querySelector('[data-add]');
    ab.disabled = !(m && m.a);
    ab.textContent = !m ? 'Choose an option' : m.a ? 'Add to cart' : 'Sold out';
  }
  function openPicker(c, opener) {
    var j = c && c.querySelector('[data-wxc-json]'); if (!j) return;
    var data; try { data = JSON.parse(j.textContent); } catch (x) { window.location.href = c.querySelector('a').href; return; }
    build();
    var sel = (c._wxSel || []).slice();
    data.options.forEach(function (o, i) { if (o.values.length === 1) sel[i] = o.values[0]; });
    cur = { card: c, data: data, sel: sel, opener: opener };
    var img = dlg.querySelector('.wxc-pick__img img'); img.src = data.img || ''; img.alt = data.title || '';
    dlg.querySelector('.wxc-pick__img').hidden = !data.img;
    dlg.querySelector('.wxc-pick__brand').textContent = data.brand || '';
    dlg.querySelector('.wxc-pick__title').textContent = data.title || '';
    dlg.querySelector('.wxc-pick__view').href = data.url;
    dlg.querySelector('.wxc-pick__err').textContent = '';
    render();
    dlg.hidden = false; document.body.classList.add('wxc-pick-open');
    dlg.querySelector('.wxc-pick__box').focus();
  }
  function close(keep) {
    if (!dlg || dlg.hidden) return;
    var c = cur.card, m = match();
    if (keep && m) {
      c._wxSel = cur.sel.slice();
      var t = c.querySelector('[data-wxc-sel]'), em = c.querySelector('[data-wxc-sel-em]'), sb = c.querySelector('[data-wxc-open]');
      if (t) t.textContent = m.t; if (em) em.textContent = 'Change'; if (sb) { sb.classList.add('is-set'); sb.title = m.t; }
      setVariant(c, m.a ? String(m.id) : '', m.p, m.c, '');
    }
    dlg.hidden = true; document.body.classList.remove('wxc-pick-open');
    if (cur.opener) cur.opener.focus({ preventScroll: true });
  }

  /* Phones: native size picker on the Add button (.wxh-card__go). Picking a size sets the variant like a chip does. */
  document.addEventListener('change', function (e) {
    var s = e.target.closest ? e.target.closest('[data-wxc-native]') : null;
    if (!s || !cardOf(s)) return;
    var c = cardOf(s), o = s.options[s.selectedIndex], go = s.closest('[data-wxc-go]');
    if (!o || !o.value) return;
    var t = o.dataset.l || o.textContent.split(' · ')[0];
    c.querySelectorAll('[data-wxc-chip]').forEach(function (x) { var on = x.dataset.id === o.value; x.setAttribute('aria-checked', on ? 'true' : 'false'); x.classList.toggle('is-on', on); });
    setVariant(c, o.value, o.dataset.p, o.dataset.c, t);
    var b = c.querySelector('[data-wxc-btn]');
    if (b) b.textContent = t && t.length <= 8 ? 'Add ' + t : 'Add to cart';
    if (go) { go.classList.add('is-picked'); var tg = go.querySelector('[data-wxc-tog]'); if (tg) tg.textContent = t; }
  });

  /* Size sheet on every screen size (instead of the browser's own select list). Rows are built from the card's hidden select. */
  var sz = null, szSel = null, szOpener = null;
  function szBuild() {
    sz = document.createElement('div'); sz.className = 'wxc-sz'; sz.hidden = true;
    sz.innerHTML = '<div class="wxc-sz__scrim" data-sz-x></div><div class="wxc-sz__panel" role="dialog" aria-modal="true" aria-labelledby="wxcSzT" tabindex="-1"><div class="wxc-sz__head"><img class="wxc-sz__img" alt=""><div class="wxc-sz__t"><small></small><b id="wxcSzT"></b></div><button type="button" class="wxc-sz__x" data-sz-x aria-label="Close">✕</button></div><div class="wxc-sz__k"></div><div class="wxc-sz__list" role="listbox"></div></div>';
    document.body.appendChild(sz);
    sz.addEventListener('click', function (e) {
      if (e.target.closest('[data-sz-x]')) { szClose(); return; }
      var r = e.target.closest('[data-sz-v]'); if (!r || r.disabled || !szSel) return;
      szSel.value = r.dataset.szV; szSel.dispatchEvent(new Event('change', { bubbles: true })); szClose();
    });
  }
  function szOpen(sel, opener) {
    if (!sz) szBuild();
    szSel = sel; szOpener = opener;
    var c = cardOf(sel), img = c.querySelector('.wxh-card__media img'), br = c.querySelector('.wxh-card__brand'), ti = c.querySelector('.wxh-card__title');
    var im = sz.querySelector('.wxc-sz__img');
    if (img) { im.src = img.currentSrc || img.src; im.hidden = false; } else { im.hidden = true; }
    sz.querySelector('.wxc-sz__t small').textContent = br ? br.textContent.trim() : '';
    sz.querySelector('.wxc-sz__t b').textContent = ti ? ti.textContent.trim() : '';
    sz.querySelector('.wxc-sz__k').textContent = sel.options[0] ? sel.options[0].textContent.trim() : 'Select size';
    var list = sz.querySelector('.wxc-sz__list'); list.innerHTML = '';
    Array.prototype.forEach.call(sel.options, function (o) {
      if (!o.value) return;
      var b = document.createElement('button'), on = sel.value === o.value;
      b.type = 'button'; b.className = 'wxc-sz__row' + (on ? ' is-on' : ''); b.dataset.szV = o.value;
      b.setAttribute('role', 'option'); b.setAttribute('aria-selected', on ? 'true' : 'false');
      if (o.disabled) b.disabled = true;
      var l = document.createElement('span'); l.className = 'wxc-sz__l'; l.textContent = o.textContent.split(' · ')[0].trim();
      var p = document.createElement('span'); p.className = 'wxc-sz__p';
      if (o.disabled) { p.textContent = 'Sold out'; }
      else { p.textContent = o.dataset.p || ''; if (o.dataset.c) { var s = document.createElement('s'); s.textContent = o.dataset.c; p.appendChild(s); } }
      b.appendChild(l); b.appendChild(p); list.appendChild(b);
    });
    sz.hidden = false; document.body.classList.add('wxc-sz-open');
    requestAnimationFrame(function () { sz.classList.add('is-in'); });
    var first = list.querySelector('.is-on') || list.querySelector('.wxc-sz__row:not([disabled])');
    if (first) first.focus({ preventScroll: true });
  }
  function szClose() {
    if (!sz || sz.hidden) return;
    sz.classList.remove('is-in'); sz.hidden = true; document.body.classList.remove('wxc-sz-open');
    if (szOpener) szOpener.focus({ preventScroll: true });
  }
  function szTrigger(e) {
    var t = e.target.closest ? e.target.closest('.wxh-card__go.has-size .wxh-card__tog') : null;
    if (!t) return;
    var sel = t.querySelector('[data-wxc-native]'); if (!sel) return;
    e.preventDefault(); szOpen(sel, t);
  }
  document.addEventListener('click', szTrigger);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sz && !sz.hidden) { szClose(); return; }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('wxh-card__tog')) szTrigger(e);
  });
})();
